import React from 'react'
import TasteOfGoldBackground from './components/TasteOfGoldBackground'
import TasteOfGoldBannerContent from './components/TasteOfGoldBannerContent'
import TasteOfGoldHeroTitleContent from './components/TasteOfGoldHeroTitleContent'
import TasteOfGoldHeroSubtitleContent from './components/TasteOfGoldHeroSubtitleContent'
import { TASTE_OF_GOLD_TAKEOVER_ID } from './constants/tasteOfGoldConstants'

const tasteOfGoldTakeoverConfig: App.SiteTakeoverConfig = {
  id: TASTE_OF_GOLD_TAKEOVER_ID,
  palette: 'inverse',
  verticals: new Set(['home', 'hotel', 'tours', 'cruise', 'flights', 'villas']),
  backgroundElement: TasteOfGoldBackground,
  siteWide: {
    banner: {
      description: <TasteOfGoldBannerContent />,
      align: 'start',
      tabletAlign: 'center',
      showOnHomePage: false,
      palette: 'inverse',
    },
  },
  searchPage: {
    bannerContent: <TasteOfGoldBannerContent centered />,
  },
  heroSection: {
    title: <TasteOfGoldHeroTitleContent />,
    subtitle: <TasteOfGoldHeroSubtitleContent variant="full" />,
    palette: 'inverse',
    carouselPalette: 'default',
    verticals: new Set(['home']),
  },
}

export default tasteOfGoldTakeoverConfig
